function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const Sentry = require("@sentry/nextjs");
export const getEnrichedLeadData = function() {
    var _ref = _async_to_generator(function*(email) {
        try {
            const url = `/contact-sales/enrichment?${new URLSearchParams({
                email
            })}`;
            const response = yield fetch(url, {
                method: "GET"
            });
            if (response.status !== 200) {
                Sentry.captureMessage(`getEnrichedLeadData Failed with status ${status}`);
                return {
                    success: false
                };
            }
            const leadData = yield response.json();
            return {
                data: leadData,
                success: true
            };
        } catch (err) {
            Sentry.captureException(err);
            Sentry.captureMessage(`getEnrichedLeadData Failed with error ${err === null || err === void 0 ? void 0 : err.message}`);
            return {
                success: false
            };
        }
    });
    return function getEnrichedLeadData(email) {
        return _ref.apply(this, arguments);
    };
}();
